module.exports = __webpack_public_path__ + "img/13.010ff067.jpg";